// frontend/src/state/analysis/analysisInitialState.js
// Purpose: Define the initial state for the analysis slice of the Redux store.
// Desired outcome: Maintain a single source of truth for all workflow states, including the state for scenario_C results.

const analysisInitialState = {
  // Current file being analyzed
  currentFile: null,
  
  // Progress tracking state
  progress: {
    status: 'idle',
    currentStep: '',
    percentComplete: 0
  },
  
  // File selection step
  fileSelection: {
    files: [], // Available files
    loading: false,
    error: null
  },
  
  // Mapping step
  mapping: {
    fields: [], // Available fields for mapping
    suggestedMappings: {}, // Automatically suggested mappings
    confirmedMappings: {}, // User-confirmed mappings
    loading: false,
    error: null
  },
  
  // Part matching step
  matching: {
    partMatches: [], // Matched parts with categories
    confidenceThreshold: 70, // Default threshold for automatic matching
    loading: false,
    error: null
  },
  
  // Part contextualization step
  context: {
    contextualizedParts: [], // Parts with filled-in data
    loading: false,
    error: null
  },
  
  // Calculation step
  calculations: {
    data: null, // Stores calculation results (e.g., cost, lead time, CO₂ footprint)
    readinessCheck: null,
    status: 'pending',
    loading: false, // Tracks whether calculations are in progress
    error: null, // Stores any calculation-related errors
    scenario_A: { // State for scenario A results
      data: null,
      loading: false,
      error: null,
    },
    scenario_B: { // State for scenario B results
      data: null,
      loading: false,
      error: null,
    },
    scenario_C: { // State for scenario C results
      data: null,
      loading: false,
      error: null,
    }
  },
  
  // Value savings analysis step
  valueSavings: {
    data: null,
    loading: false,
    error: null,
    assumptions: {
      annualHoldingCostPct: 0.20,
      obsolescencePct_current: 0.10,
      obsolescencePct_onDemand: 0.01,
      warehouseSetupCost: 100000,
      annualWarehouseOperationalCost: 50000,
      responsivenessRevenueIncreasePct: 0.02
    },
    scenarioType: 'brownfield'
  },
  
  // Report generation step
  report: {
    data: null,
    downloadURLs: null,
    generating: false,
    generatedAt: null,
    error: null
  },
  
  // Current step in the workflow
  currentStep: 1, // 1 = File Selection, 2 = Mapping, 3 = Matching, 4 = Calculation, 5 = Report
  
  // Overall analysis status
  status: 'pending', // 'pending', 'complete'
  
  // Error state
  error: null
};

export default analysisInitialState;